import React, { useState } from 'react';
import { Card, Button, TextField, Banner, Layout, Page } from '@shopify/polaris';
import apiService from '../services/api';

export const TestBackend: React.FC = () => {
  const [email, setEmail] = useState('test@example.com');
  const [password, setPassword] = useState('password123');
  const [firstName, setFirstName] = useState('Test');
  const [lastName, setLastName] = useState('User');
  const [result, setResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const testRegistration = async () => {
    setLoading(true);
    setResult('');
    
    try {
      const response = await apiService.register({
        email,
        password,
        firstName,
        lastName
      });
      
      if (response.data) {
        setResult(`✅ Registration successful! Token: ${response.data.token.substring(0, 50)}...`);
      } else {
        setResult(`❌ Registration failed: ${response.error}`);
      }
    } catch (error) {
      setResult(`❌ Error: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setLoading(false);
    }
  };

  const testLogin = async () => {
    setLoading(true);
    setResult('');
    
    try {
      const response = await apiService.login({
        email,
        password
      });
      
      if (response.data) {
        setResult(`✅ Login successful! Token: ${response.data.token.substring(0, 50)}...`);
      } else {
        setResult(`❌ Login failed: ${response.error}`);
      }
    } catch (error) {
      setResult(`❌ Error: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setLoading(false);
    }
  };

  const testTokenValidation = async () => {
    setLoading(true);
    setResult('');
    
    try {
      const response = await apiService.validateToken();
      
      if (response.data) {
        setResult(`✅ Token validation successful! User: ${JSON.stringify(response.data.user)}`);
      } else {
        setResult(`❌ Token validation failed: ${response.error}`);
      }
    } catch (error) {
      setResult(`❌ Error: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page title="Backend API Test">
      <Layout>
        <Layout.Section>
          <Card>
            <div style={{ padding: '20px' }}>
              <h2>Backend API Integration Test</h2>
              <p>This page tests the connection between the frontend and backend API.</p>
              
              <div style={{ marginBottom: '20px' }}>
                <TextField
                  label="Email"
                  value={email}
                  onChange={setEmail}
                  autoComplete="email"
                />
              </div>
              
              <div style={{ marginBottom: '20px' }}>
                <TextField
                  label="Password"
                  value={password}
                  onChange={setPassword}
                  type="password"
                  autoComplete="current-password"
                />
              </div>
              
              <div style={{ marginBottom: '20px' }}>
                <TextField
                  label="First Name"
                  value={firstName}
                  onChange={setFirstName}
                  autoComplete="given-name"
                />
              </div>
              
              <div style={{ marginBottom: '20px' }}>
                <TextField
                  label="Last Name"
                  value={lastName}
                  onChange={setLastName}
                  autoComplete="family-name"
                />
              </div>
              
              <div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
                <Button onClick={testRegistration} loading={loading} variant="primary">
                  Test Registration
                </Button>
                <Button onClick={testLogin} loading={loading}>
                  Test Login
                </Button>
                <Button onClick={testTokenValidation} loading={loading}>
                  Test Token Validation
                </Button>
              </div>
              
              {result && (
                <Banner
                  title="Test Result"
                  tone={result.includes('✅') ? 'success' : 'critical'}
                >
                  <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                    {result}
                  </pre>
                </Banner>
              )}
            </div>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}; 